/**
 * Created by user on 2020/1/14.
 */

import findLibrarys from './lib/findLibrarys';
import loadLibrary from './lib/loadLibrary';
import createDB from './lib/DB';
import fileext from './lib/utils/fileext';
import { getFilePath } from './lib/utils/index';
export * from './lib/types';

export {
	findLibrarys,
	loadLibrary,
	createDB,
}

export {
	fileext,
	getFilePath,
}

export default createDB
